const QUALITIES = [0.85, 0.7, 0.55, 0.4]
const FORMATS: ('image/webp' | 'image/jpeg')[] = ['image/webp', 'image/jpeg']

export function compressImage(file: File, maxBytes: number, maxDim = 1200): Promise<File> {
  if (file.size <= maxBytes) return Promise.resolve(file)

  return new Promise((resolve, reject) => {
    const img = new Image()
    const objectUrl = URL.createObjectURL(file)

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl)
      reject(new Error('Failed to load image'))
    }

    img.onload = () => {
      URL.revokeObjectURL(objectUrl)

      let { width, height } = img
      if (width > maxDim || height > maxDim) {
        if (width >= height) {
          height = Math.round((height * maxDim) / width)
          width = maxDim
        } else {
          width = Math.round((width * maxDim) / height)
          height = maxDim
        }
      }

      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        resolve(file)
        return
      }
      ctx.drawImage(img, 0, 0, width, height)

      function attempt(fIdx: number, qIdx: number) {
        if (fIdx >= FORMATS.length) {
          resolve(file)
          return
        }
        const format = FORMATS[fIdx]
        const quality = QUALITIES[qIdx]
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              resolve(file)
              return
            }
            if (blob.size <= maxBytes) {
              const ext = format === 'image/webp' ? 'webp' : 'jpg'
              const name = file.name.replace(/\.[^.]+$/, `.${ext}`)
              resolve(new File([blob], name, { type: format }))
            } else if (qIdx + 1 < QUALITIES.length) {
              attempt(fIdx, qIdx + 1)
            } else {
              attempt(fIdx + 1, 0)
            }
          },
          format,
          quality,
        )
      }

      attempt(0, 0)
    }

    img.src = objectUrl
  })
}
